import React from 'react';
import CallDashboard from './components/CallDashboard';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <CallDashboard />
    </div>
  );
}

export default App;